export default "__VITE_ASSET__DsBesYGy__"